"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultEformState2 = exports.defaultEformState1 = void 0;
var EformStatus_1 = require("@/pages/document/states/EformStatus");
var EformTypes_1 = require("@/pages/document/states/EformTypes");
var EformPropertyState_init_1 = require("@/pages/document/states/EformPropertyState.init");
exports.defaultEformState1 = {
    title: 'Property Information Form (for use in the sale and purchase of residential properties in Hong Kong)',
    signingUrl: 'https://google.com',
    type: EformTypes_1.EformTypes.EAA_FORM_3,
    status: EformStatus_1.EformStatus.WAITING_ME,
    status_date: '23 Dec 2023 17:30',
    properties: [
        EformPropertyState_init_1.defaultEformPropertyState1,
    ]
};
exports.defaultEformState2 = {
    title: 'Estate Agency Agreement for Leasing of Residential Properties in Hong Kong (for use between an estate agent and a tenant)',
    type: EformTypes_1.EformTypes.EAA_FORM_6,
    signingUrl: 'https://google.com',
    status: EformStatus_1.EformStatus.WAITING_ME,
    status_date: '11 Nov 2023 12:30',
    properties: [
        EformPropertyState_init_1.defaultEformPropertyState1,
        EformPropertyState_init_1.defaultEformPropertyState2,
    ],
    caption_1: '23 Dec 2023 Viewing'
};
